function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListPoliza from "./ListPoliza";
import ModalPoliza from "./components/ModalPoliza/ModalPoliza";
import { ReactiveBase, ReactiveList, DataSearch, MultiDropdownList, DateRange, SelectedFilters, ToggleButton } from "@appbaseio/reactivesearch";
import "moment/locale/es";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import _ from "lodash";
import "../../helperComponents/Elasticsearch/elasticsearch.scss";

var IndexPoliza = function IndexPoliza(props) {
  var admin = props.admin;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedPoliza = _React$useState2[0],
      setSelectedPoliza = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openModal = _React$useState4[0],
      setOpenModal = _React$useState4[1];

  var componentIds = function componentIds() {
    var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var filters = ['poliza_renewal', 'poliza_ramo', 'poliza_renewal_status_name', 'poliza_tipo_de_pago', 'poliza_company_name', 'poliza_nombre_contratante', 'poliza_nombre_asegurado', 'poliza_id', 'poliza_finish_date', 'poliza_substatus_clean', 'poliza_endorsement_status', 'created_at', 'updated_at', 'was_sent', 'sent_at'];
    return _.without(filters, except);
  };

  var defaultQuery = function defaultQuery() {
    return {
      timeout: "10s",
      query: {
        match_all: {}
      },
      size: 1
    };
  };

  var renderList = function renderList() {
    return /*#__PURE__*/React.createElement(ReactiveList, {
      componentId: "PolizasList" //highlight
      ,
      dataField: "updated_at",
      pagination: true,
      size: 50,
      loader: "Cargando resultados...",
      sortBy: "desc",
      showResultStats: true,
      react: {
        and: componentIds()
      },
      render: function render(_ref) {
        var data = _ref.data;
        return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
          style: {
            overflow: "auto"
          }
        }, data.id, /*#__PURE__*/React.createElement(ListPoliza, {
          polizas: data,
          onSelectedPoliza: onSelectedPoliza,
          admin: admin
        }));
      }
    });
  };

  var onSelectedPoliza = function onSelectedPoliza(poliza) {
    setSelectedPoliza(poliza);
    setOpenModal(true);
  };

  var renderOptions = function renderOptions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      componentId: "poliza_id",
      dataField: ["id_keyword", "code", "poliza_endorsements.id_keyword", "asegurado.rut", "contratante.rut", "beneficiario.rut", "asegurado.full_name", "contratante.full_name", "beneficiario.full_name", "item_asegurados.materia_asegurada", "item_asegurados.risk_address", "item_asegurados.patente"],
      queryFormat: "and",
      fuzziness: 2,
      title: "N\xBA propuesta, p\xF3liza, endoso o datos de contratante/beneficiario/asegurado, Materia o Direcci\xF3n asegurado o Patente",
      placeholder: "Buscar por n\xFAmero de propuesta, c\xF3digo de poliza, c\xF3digo del endoso o datos de contratante/beneficiario/asegurado" //defaultQuery={defaultQuery}
      ,
      autosuggest: false // somehow it crashes with this
      ,
      react: {
        and: componentIds("poliza_id")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_ramo",
      dataField: "ramo.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Ramo",
      title: "Ramo",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_ramo")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "renewal",
      dataField: "renewal",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Renovaci\xF3n",
      title: "Renovaci\xF3n?",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_renewal")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_renewal_status_name",
      dataField: "status_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Estado de la poliza",
      title: "Estado de la poliza",
      URLParams: false //loader="..."
      ,
      react: {
        and: componentIds("poliza_renewal_status_name")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_tipo_de_pago",
      dataField: "tipo_de_pago.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Forma de pago",
      title: "Forma de pago",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_tipo_de_pago")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_company_name",
      dataField: "company.name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Compa\xF1\xEDa",
      title: "Compa\xF1\xEDa",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_company_name")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_substatus_clean",
      dataField: "substatus_clean.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Sub-estado de la poliza",
      title: "Sub-estado de la poliza",
      URLParams: false //loader="..."
      ,
      react: {
        and: componentIds("poliza_substatus_clean")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_contratante",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery //dataField="poliza.document_data.nombre_contratante.keyword"
      ,
      dataField: "contratante.full_name.keyword" //nestedField="poliza.document_data"
      ,
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre contratante",
      title: "Contratante",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_contratante")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_asegurado",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "asegurado.full_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre Asegurado",
      title: "Asegurado",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_asegurado")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_endorsement_status",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "endorsement_status.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Estado de endosos",
      title: "Estado de endosos",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_endorsement_status")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      componentId: "poliza_finish_date",
      className: "col-md-4 elasticsearch-component" //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "finish_date",
      title: "Fecha de fin vigencia",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      componentId: "created_at",
      className: "col-md-4 elasticsearch-component" //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "created_at",
      title: "Fecha de creaci\xF3n",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "updated_at",
      dataField: "updated_at",
      title: "Fecha de \xFAltima actualizaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "sent_at",
      dataField: "sent_at",
      title: "Fecha de env\xEDo",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha de env\xEDo",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(ToggleButton, {
      className: "col-md-4 elasticsearch-component clear-button",
      componentId: "was_sent",
      dataField: "was_sent",
      data: [{
        "label": "Sin enviar",
        "value": false
      }],
      filterLabel: "was_sent",
      multiSelect: false,
      showFilter: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(SelectedFilters, {
      className: "elasticsearch-component",
      showClearAll: true,
      clearAllLabel: "Limpiar filtros"
    })));
  };

  return /*#__PURE__*/React.createElement("div", null, selectedPoliza && /*#__PURE__*/React.createElement(ModalPoliza, {
    poliza: selectedPoliza,
    open: openModal,
    onClose: function onClose() {
      setSelectedPoliza(null);
      setOpenModal(false);
    }
  }), /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "polizas",
    url: "".concat(process.env.SEGUROS_API_URL),
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, renderOptions()), renderList()));
};

export default IndexPoliza;